// src/components/layouts/BareLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

const BareLayout = () => {
    return <Outlet />;
};

export default BareLayout;
